var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avue-crud',{attrs:{"option":_vm.option,"before-open":_vm.beforeOpen,"data":_vm.data},on:{"row-save":_vm.rowSave,"row-update":_vm.rowUpdate,"row-del":_vm.rowDel},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})
}
var staticRenderFns = []

export { render, staticRenderFns }